var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:none;}.aGuestIcon{stroke:#65c8ff;stroke-miterlimit:10;stroke-width:2px;}.b,.c{fill:#141416;}.c{fill-rule:evenodd;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "aGuestIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 48,
    height: 48,
    rx: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 23
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9,2A7,7,0,0,0,2,9v2a1,1,0,0,1-2,0V9A9,9,0,0,1,18,9v2a1,1,0,0,1-2,0V9A7,7,0,0,0,9,2Z",
    transform: "translate(3 11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M6,10A4,4,0,1,0,2,6,4,4,0,0,0,6,10Zm0,2A6,6,0,1,0,0,6,6,6,0,0,0,6,12Z",
    transform: "translate(6 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestsIcon);
export default __webpack_public_path__ + "static/media/guests-icon.5e446d28a4e043801b90aebc0d64266a.svg";
export { ForwardRef as ReactComponent };